/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any*/

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './NocDashboard.css'
import { ThemeProvider } from '@mui/material/styles';
import { AutoRefresh, DashboardHeader, DashboardLoader, DashboardTheme, HorizontalNavbar, renderHeaderActionButtons, SearchBox, TableSubHeader, useAppDispatch, useAppSelector, useEffectOnce } from '../../../globalUtils/globalExports';

import { Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { getAcFilterReducer, getacNocDashboardReducer, getAcReferenceDataReducer } from '../../rmsReduxStore/acReduxExports';
import { fetchAcLatestChargerDetails, fetchAcNocDashboardAlertCount, fetchAcNocDashboardAlertsList, fetchAcNocDashboardChargerAlarm, fetchAcNocDashboardChargerAnalyticsData, fetchAcNocDashboardChargerList, fetchAcNocDashboardChargerPerfomanceRankings, fetchAcNocDashboardChargerSessionPerfomance, fetchAcNocDashboardChargerSessionVolume, fetchAcNocDashboardChargerSummary, fetchAcNocDashboardChargerUptime, setNocDashboardActiveTab } from '../../rmsReduxStore/acNocDashboardRedux/acNocDashboardCreator';
import { getAcFilterSelectedValue, getCurrentAcFiltersValues, getCurrentScreenAppliedAcFiltersCount, setAcFilterData } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import { getFilterSelectedValue, setFilterData, setHideSideBar } from '../../../rmsReduxStore/reduxExports';
import AcAlertsPanel from './AcAlertsPanel';
import AcCustomNOCMap from './AcCustomNOCMap';
import CustomMapControl from './CustomMapControl';
import AlarmsUptimeTrendChart from './AlarmUptimeChart';
import ChargingSessionAreaChart from './ChargingSessionAreaChart';
import CustomNocMapFilters from './CustomNocMapFilters';
import NocLegends from './NocLegends';
import StackedColumnChart from './StackedColumnChart';
import CustomPulseLoader from '../../../components/softwareReleaseManagement/dashboard/CustomPulseLoader';
import AcFilterLayout, { FilterProp } from '../../../globalUtils/FilterLayout/AcFilterLayout';
import AcCustomFilterLayout from '../dashboard/AcCustomFilterLayout';
import AcNocChargerPerfomanceSidePanel from './NocChargerPerfomanceSidePanel';
import AcNocRightPanel from './AcNocRightPanel';
import AcNocmetricCardOverlay from './NocmetricCardOverlay';





const AcNocDashboard: React.FC = (props) => {
  const dispatch = useAppDispatch();
  const [mapZoom, setMapZoom] = useState<number>(5);
  const [expandedMap, setExpandedMap] = useState<boolean>(true);
  const [openAlertList, setOpenAlertList] = useState<boolean>(false);
  const [showDashboardLoader, setShowDashboardLoader] = useState(false);
  const { chargerProductTypeReferenceData,chargingStationReferenceData ,chargerVisibleIdReferenceData} = useAppSelector(getAcReferenceDataReducer);
  const [showLegends, setShowLegends] = useState(false);
  const [isFlagged, setIsFlagged] = useState<boolean>(false);
  const { latestChargerDetails, nocDashboardChargerList, nocDashboardAlertsCount, nocDashboardAlertsList, latestChargerAlarmDetails, latestChargerDetailsLoader, nocDashboardChargingSessionsPlotData, nocDashboardConsumedEnergyPlotData, nocDashboardChargerUptimePlotData, nocDashboardConnectorStatusData, nocDashboardMapCenterCoordinates,nocDashboardAlarmCounts ,nocDashboardChargerSessionPerfomanceData,nocDashbaordChargerSessionVolumeData,nocDashboardChargerUptimeData , nocDashboardChargerAlarmData, nocDashboardActiveTab } = useAppSelector(getacNocDashboardReducer);
  const [showSideBar, setShowSideBar] = useState<boolean>(false);
  const [enableUserInteraction, setEnableUserInteraction] = useState<boolean>(true);
  const [selectedCharger, setSelectedCharger] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const { screenFilters } = useAppSelector(getAcFilterReducer);
  const [showNocMetricCardBar, setShowNocMetricCardBar] = useState(true);
  const searchTermRef = useRef<string | null>(null);
  const selectedChargerRef = useRef<string | null>(null);
  const intervalRef = useRef<any>(null);
  const alarmDurationRef = useRef<string | null>(null);
  const [showMapInFullView, setShowMapInFullView] = useState<boolean>(false);
  const [mapCenter, setMapCenter] = useState<{ [key: string]: number }>(nocDashboardMapCenterCoordinates ? { lat: nocDashboardMapCenterCoordinates?.lat, lng: nocDashboardMapCenterCoordinates?.lon } : { lat: 20.5, lng: 78.9 });
  const [prevMapCenter,setPrevMapCenter] = useState<{ [key: string]: number }>(nocDashboardMapCenterCoordinates ? { lat: nocDashboardMapCenterCoordinates?.lat, lng: nocDashboardMapCenterCoordinates?.lon } : { lat: 20.5, lng: 78.9 });
  const [selectedNav, setSelectedNav] = useState<string>(nocDashboardActiveTab ? nocDashboardActiveTab : 'liveTopologyMap'); //activeTab = 'liveTopologyMap' | 'perfomanceAnalytics';
  const perfomanceRankingNavRef = useRef<'uptime'| 'utilisation'| 'efficiency'>('uptime');
  const [refreshDate, setRefreshDate] = useState<Date>(new Date());
  const [analyticsRefreshDate,setAnalyticsRefreshDate] = useState<Date>(new Date());
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLElement | null>(
        null
    );
  const [chartKey, setChartKey] = useState(0);

  const handlePerformanceRankingNavChange = (value) => {
  perfomanceRankingNavRef.current = value;
//   const perfomanceAnalyticsFilters = getCurrentFiltersValues('nocPerfomanceAnalytics',false);
//   dispatch(fetchNocDashboardChargerPerfomanceRankings({fetchType: perfomanceRankingNavRef.current ?? '',filters:perfomanceAnalyticsFilters,searchTerm:''}))
  };

  const headerdata = [
        {
                id: 'liveTopologyMap',
                text: 'Live Topology Map ',
                isAccessible: true,
        },
        {
                id: 'perfomanceAnalytics',
                text: 'Perfomance Analytics',
                isAccessible: true,
        },
        ];

    const handleNavBtnClick = useCallback((val) => {
            setSelectedNav(val);
            dispatch(setNocDashboardActiveTab(val));
            if(val === 'perfomanceAnalytics')fetchPerformanceAnalytics();
            else {
                const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);
                fetchNOCDashboard(nocDashboardFilter, '', '', true)
            }
        }, [selectedNav]);
    
  // const alertsLists = nocDashboardAlertsList | [];
  const ToogleAlertFilter = async () => {
    const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);

    const newFlagState = !isFlagged;
    setIsFlagged(newFlagState);

    const fetchType = newFlagState ? 'flaggedAlerts' : '';

    await dispatch(
      fetchAcNocDashboardAlertsList({
        filters: nocDashboardFilter,
        searchTerm,
        fetchType
      })
    );
  };

    const navBarconfigurations = useMemo(() => {
      return {
        selectedNav: selectedNav,
        navList: headerdata?.filter((nav) => nav?.isAccessible),
        onNavClick: handleNavBtnClick,
      };
    }, [selectedNav]);

  const fetchNOCDashboard = (incomingFilters, charger?: string, searchTerm?: string, callDashboard?: boolean) => {
    const filters = incomingFilters?.filter(filter => filter?.key !== 'mapDefaultView');
    dispatch(fetchAcLatestChargerDetails({ filters, charger, searchTerm, alarmDuration: alarmDurationRef.current }));
    dispatch(fetchAcNocDashboardChargerAnalyticsData({ filters, charger, searchTerm }));
    if (callDashboard) {
      dispatch(fetchAcNocDashboardChargerList({ filters, searchTerm }));
    }
    dispatch(fetchAcNocDashboardAlertCount({ filters, searchTerm }));

  }

  const fetchPerformanceAnalytics = () => {
        const perfomanceAnalyticsFilters = getCurrentAcFiltersValues(
            'nocPerfomanceAnalytics',
            false,
        );
        dispatch(
            fetchAcNocDashboardChargerPerfomanceRankings({
                fetchType: 'uptime',
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerPerfomanceRankings({
                fetchType: 'utilization',
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerPerfomanceRankings({
                fetchType: 'efficiency',
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerSummary({
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerSessionPerfomance({
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerSessionVolume({
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerUptime({
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
        dispatch(
            fetchAcNocDashboardChargerAlarm({
                filters: perfomanceAnalyticsFilters,
                searchTerm: '',
            }),
        );
    };



  useEffectOnce(() => {
    // fetchPerformanceAnalytics();
    // intervalRef.current = setInterval(() => {
    //   const nocDashboardFilter = getCurrentFiltersValues('nocDashboard', false);
    //   const charger = searchTermRef?.current ? '' : selectedChargerRef?.current ? selectedChargerRef?.current : '';
    //   const searchText = searchTermRef?.current ? searchTermRef?.current : '';
    //   fetchNOCDashboard(nocDashboardFilter, charger, searchText, true);
    // }, 60000);
    if(nocDashboardActiveTab === 'perfomanceAnalytics') {
        fetchPerformanceAnalytics();
    }
    else {
        const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);
        fetchNOCDashboard(nocDashboardFilter, '', '', true)
    }

  })


  const handleFilterDataChange = useCallback(async (data, filterKey: string, isGlobal: boolean) => {
    const res = await setAcFilterData(data, filterKey, 'nocDashboard', 'SET', isGlobal, false)(dispatch);
    if (res?.message === 'Action dispatched successfully') {
      if (filterKey === 'mapDefaultView') {
        await setFilterData(data, filterKey, 'nocDashboard', 'SET', isGlobal, false)(dispatch);
        return;
      }
      const currSearchTerm = searchTerm ? searchTerm : '';
      fetchNOCDashboard(res?.filters, '', currSearchTerm, true)
    }
  }, []);

  const handlePerfomanceFilterChange = useCallback(async (data, filterKey: string, isGlobal: boolean) => {
    const res = await setAcFilterData(data, filterKey, 'nocPerfomanceAnalytics', 'SET', isGlobal, false)(dispatch);
    if (res?.message === 'Action dispatched successfully') {
    fetchPerformanceAnalytics();
    }
  }, []);


  const quickDateSelectOptions =[
          { label: 'Last 24hr', value: 'last24hr' },
          { label: 'Last Week', value: 'lastWeek' },
          { label: 'Last Month', value: 'lastMonth' }
  ]


  const NocFilterProps: FilterProp[] = useMemo(() => {
    return [
      // {
      //   filterLabel: 'Time Selection',
      //   filterId: 'timeSelection',
      //   filterType: 'dropdown',
      //   filterDropdownProps: {
      //     selectValue: getFilterSelectedValue('timeSelection', 'nocDashboard', false),
      //     selectOptions: ['Real Time', 'Last 24 Hrs', 'Last Week', 'Last Month']?.map(item => ({ id: item, label: item, value: item, name: item })) ?? [],
      //     handleSelectOptionChange: (val): void => {
      //       handleFilterDataChange(val, 'timeSelection', false)
      //     },
      //     selectDropDownId: 'noc-dashboard-product-type-filter-dropdown',
      //     isMultiSelect: true,
      //     renderToBody: true
      //   }
      // },
      {
        filterLabel: 'Product Type',
        filterId: 'productType',
        filterType: 'dropdown',
        filterDropdownProps: {
          selectValue: getFilterSelectedValue('productType', 'nocDashboard', false),
          selectOptions: chargerProductTypeReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'productType', false)
            handlePerfomanceFilterChange(val,'productType',false)
          },
          selectDropDownId: 'noc-dashboard-product-type-filter-dropdown',
          isMultiSelect: true,
          renderToBody: true
        }
      },
    ]
  }, [chargerProductTypeReferenceData, screenFilters, handleFilterDataChange])


  const NocChargerPerfomanceFilterProps: FilterProp[] = useMemo(() => {
        return [
            {
                filterLabel: 'Charging Stations',
                filterType: 'dropdown',
                filterId: 'chargingStationId',
                filterDropdownProps: {
                    selectValue: getAcFilterSelectedValue(
                        'chargingStationId',
                        'nocPerfomanceAnalytics',
                        false
                    ),
                    selectOptions: chargingStationReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handlePerfomanceFilterChange(val, 'chargingStationId', false);
                    },
                    selectDropDownId: 'charger-chargingStationId-type-filter-dropdown',
                    isMultiSelect: true,
                    renderToBody:true
                },
            },
            {
                filterLabel: 'Chargers',
                filterType: 'dropdown',
                filterId: 'chargerId',
                filterDropdownProps: {
                    selectValue: getAcFilterSelectedValue(
                        'chargerId',
                        'nocPerfomanceAnalytics',
                        false
                    ),
                    selectOptions: chargerVisibleIdReferenceData ?? [],
                    handleSelectOptionChange: (val): void => {
                        handlePerfomanceFilterChange(val, 'chargerId', false);
                    },
                    selectDropDownId: '-chargerId-filter-dropdown',
                    isMultiSelect: true,
                    renderToBody:true
                },
            },
            {
                filterLabel: 'Time Selection',
                filterType: 'dropdown',
                filterId: 'nocTimeSelectionInterval',
                filterDropdownProps: {
                    selectValue: getAcFilterSelectedValue(
                        'nocTimeSelectionInterval',
                        'nocPerfomanceAnalytics',
                        false
                    ),
                    selectOptions: quickDateSelectOptions ?? [],
                    handleSelectOptionChange: (val): void => {
                        handlePerfomanceFilterChange(val, 'nocTimeSelectionInterval', false);
                    },
                    selectDropDownId: '-chargerId-filter-dropdown',
                    isMultiSelect: false,
                    renderToBody:true
                },
            },
        ];
    }, [
        chargerProductTypeReferenceData,
        chargingStationReferenceData,
        screenFilters,
        handlePerfomanceFilterChange,
    ]);

  const handleMapExpansionToggle = () => {
    /* Toggles the map view for the noc dashboard */
    setExpandedMap(prev => !prev)
  }

  const headerActionBtns = renderHeaderActionButtons({
        actionBtns:
            [
                {
                    id: 'add_filter_btn',
                    isAccessible: true,
                    headerActionBtnClick: (e): void => {
                        setFilterAnchorEl(e.currentTarget)
                    },
                    badgeCount: getCurrentScreenAppliedAcFiltersCount('nocPerfomanceAnalytics',true)
                },
            ],
  })


  const onChangeOfSearchText = (searchText: string): void => {
    setSearchTerm(searchText);
    searchTermRef.current = searchText;
    setSelectedCharger(null);
    const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);
    fetchNOCDashboard(nocDashboardFilter, '', searchText, true);
  }

  const handleSelectedChargerChange = (chargerId: string): void => {
    if (chargerId === selectedChargerRef?.current) {
      setSelectedCharger(null);
      selectedChargerRef.current = null;
      const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);
      fetchNOCDashboard(nocDashboardFilter, '', '', false);
      return;
    }
    setSelectedCharger(chargerId);
    selectedChargerRef.current = chargerId;
    const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);
    fetchNOCDashboard(nocDashboardFilter, chargerId, '', false);
  }


  const searchBoxConfiguration = useMemo(() => {
    return {
      searchBoxClassName: 'noc__dashboard__search__box',
      searchFieldId: 'noc-dashboard-search-box',
      searchFieldName: 'noc-dashboard-search-box',
      handleSearch: onChangeOfSearchText,
      debounceTime: 500,
      customPlaceHolder: 'Search by charger ID, station, city, or location...'
    };
  }, [onChangeOfSearchText]);

  const handleAlertListToggle = (closeList: boolean) => {

    const filters = getCurrentAcFiltersValues('nocDashboard', false)?.filter(item=>item?.key !== 'mapDefaultView');
    if (closeList) {
      dispatch(fetchAcNocDashboardAlertCount({ filters, 'searchTerm': searchTermRef?.current }));
      setOpenAlertList(false);
    }
    else {
      dispatch(fetchAcNocDashboardAlertsList({ filters, 'searchTerm': searchTermRef?.current }));
      setOpenAlertList(true)
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef?.current) {
        clearInterval(intervalRef.current);
      }
    }
  }, [])

  const formatDate = (date: Date) => {
    const formattedDate = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    })
      .format(date)
      .replace(',', ' ');

    return formattedDate.replace(/\b(am|pm)\b/i, (match) => match.toUpperCase());
  }
  const selectedfilters = getAcFilterSelectedValue('customer', 'nocDashboard', true);
  const watermarkText = useMemo(() => {
    if (!selectedfilters || selectedfilters.length !== 1) return '';

    const selectedCustomer = selectedfilters[0];
    if (selectedCustomer.id === 'all') return '';

    return selectedCustomer.name || '';
  }, [selectedfilters]);

  const openLiveTopologyMapInFullScreen = () => {
    document.documentElement.requestFullscreen();
    setShowMapInFullView(true)
    dispatch(setHideSideBar(true)) //This is for RMS Sidebar
  }

  const exitFullScreenViewForLiveTopologyMap = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    setShowMapInFullView(false);
    dispatch(setHideSideBar(false));
    setChartKey(prev => prev + 1); // Force remount
  }

const handleLiveTopologyRefresh = () =>{
    const nocDashboardFilter = getCurrentAcFiltersValues('nocDashboard', false);
    const charger = searchTermRef?.current ? '' : selectedChargerRef?.current ? selectedChargerRef?.current : '';
    const searchText = searchTermRef?.current ? searchTermRef?.current : '';
    fetchNOCDashboard(nocDashboardFilter, charger, searchText, true);
    setRefreshDate(new Date());
}

const handlePerfomanceAnalyticsRefresh = ()=>{
    fetchPerformanceAnalytics();
    setAnalyticsRefreshDate(new Date());
}

useEffect(() => {
    const handleFullscreenChange = () => {
        if (!document.fullscreenElement) {
            setShowMapInFullView(false);
            dispatch(setHideSideBar(false));
            setChartKey((prev) => prev + 1); // Force remount
        }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
        document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
}, [dispatch]);



  return (
        <ThemeProvider theme={DashboardTheme}>
            <DashboardLoader
                handleClose={setShowDashboardLoader}
                showLoader={showDashboardLoader}
            />
            <div className='noc-dashboard-container'>
                <div className='noc-dashboard-header-container'>
                    <div className='noc-dashboard-header-left'>
                        <div className='noc-dashboard-header-heading'>
                            <div className='noc-dashboard-header-main-heading'>
                                <DashboardHeader
                                    header='NOC Dashboard'
                                    headerClassName='noc__dashboard_header'
                                />
                            </div>
                            <div className='noc-dashboard-header-sub-heading'>
                                Live System Health & Customer Impact
                            </div>
                        </div>
                        <div className='noc-dashboard-auto-refresh-wrap'></div>
                    </div>
                    <div className='noc-dashboard-header-right'>
                        <AcFilterLayout
                            filters={NocFilterProps}
                            requiredReferenceDataCallbacks={['customer', 'productType']}
                            screen='nocDashboard'
                            excludeGlobalFilters={false}
                            handleFilterDataChange={ selectedNav == 'liveTopologyMap' ? handleFilterDataChange : handlePerfomanceFilterChange}
                        />
                    </div>
                </div>

                <div
                    className={
                        showMapInFullView
                            ? selectedNav === 'liveTopologyMap'
                                ? 'noc-dashboard-body-container-full-view'
                                : 'noc-dashboard-charger-perfomance-container-full-view'
                            : selectedNav === 'liveTopologyMap'
                                ? 'noc-dashboard-body-container'
                                : 'noc-charger-performance-body-container'
                    }
                >
                    <div
                        className={
                            selectedNav === 'liveTopologyMap'
                                ? 'noc-dashboard-body-map-container'
                                : 'noc-dashboard-charger-perfomance-body-container'
                        }
                    >
                        <div className='noc-dashboard-body-map-header-container'>
                            <div className='noc-dashboard-body-map-header-left'>
                                {/* <div className='noc-dashboard-body-map-header-left-heading'>Live Topology Map</div> */}
                                <HorizontalNavbar
                                    selectedNav={navBarconfigurations?.selectedNav}
                                    navList={navBarconfigurations?.navList}
                                    onNavClick={(event, val) => {
                                        event?.stopPropagation();
                                        navBarconfigurations?.onNavClick?.(val);
                                    }}
                                />
                                <div
                                    className='noc-dashboard-body-map-header-left-map-full-view-icon-container'
                                    onClick={
                                        showMapInFullView
                                            ? exitFullScreenViewForLiveTopologyMap
                                            : openLiveTopologyMapInFullScreen
                                    }
                                >
                                    <Icon
                                        iconClassName={
                                            showMapInFullView
                                                ? 'noc-dashboard-body-map-header-left-map-hide-full-view-icon'
                                                : 'noc-dashboard-body-map-header-left-map-show-full-view-icon'
                                        }
                                    />
                                </div>
                            </div>
                            <div className='noc-dashboard-search-box-container'>
                                {selectedNav === 'liveTopologyMap' ? (
                                    <div className='noc-dashboard-header-right'>
                                    <AutoRefresh
                                                refreshDate={refreshDate}
                                                containerClassName='charger__auto__refresh__component'
                                                onRefreshCallback={ handleLiveTopologyRefresh}
                                                pathName='/noc-dashboard'
                                                refreshLocation={false}
                                    />
                                    <SearchBox
                                        searchFieldId={searchBoxConfiguration?.searchFieldId}
                                        searchBoxClassName={
                                            searchBoxConfiguration?.searchBoxClassName
                                        }
                                        handleSearch={searchBoxConfiguration?.handleSearch}
                                        debounceTime={searchBoxConfiguration?.debounceTime}
                                        customPlaceHolder={
                                            searchBoxConfiguration?.customPlaceHolder
                                        }
                                    />

                                            </div>									
                                ) : (
                                    <>
                                        <div className='noc-dashboard-header-right'>
                                            {/* <FilterLayout
                                                filters={NocChargerPerfomanceFilterProps}
                                                requiredReferenceDataCallbacks={[
                                                    'chargingStation',
                                                    'chargerVisibleId',
                                                ]}
                                                screen='nocDashboard'
                                                excludeGlobalFilters={true}
                                                handleFilterDataChange={handleFilterDataChange}
                                            /> */}
                                            <AutoRefresh
                                                refreshDate={analyticsRefreshDate}
                                                containerClassName='charger__auto__refresh__component'
                                                onRefreshCallback={ handlePerfomanceAnalyticsRefresh}
                                                pathName='/noc-dashboard'
                                                refreshLocation={false}
                                            />
                                            <TableSubHeader headerActionBtns={headerActionBtns} />
                                            <AcCustomFilterLayout
                                                filters={NocChargerPerfomanceFilterProps}
                                                requiredReferenceDataCallbacks={[
                                                    'chargingStation',
                                                    'chargerVisibleId',
                                                ]}
                                                filterAnchorEl={filterAnchorEl}
                                                setFilterAnchorEl={setFilterAnchorEl}
                                                excludeGlobalFilters={true}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <AcAlertsPanel
                            open={openAlertList}
                            onClose={() => handleAlertListToggle(true)}
                            alertsLists={nocDashboardAlertsList}
                            ToogleAlertFilter={ToogleAlertFilter}
                            isFlagged={isFlagged}
                            alertCount={Number(nocDashboardAlertsCount)}
                        />
                        <div
                            className={
                                selectedNav === 'liveTopologyMap'
                                    ? 'noc-dashboard-body-map-body-container'
                                    : 'noc-dashboard-body-charger-perfomance-body-container'
                            }
                        >
                            {selectedNav === 'liveTopologyMap' ? (
                                <>
                                    <div
                                        className={
                                            !showSideBar
                                                ? 'noc-dashboard-body-map-body-container-map-full-height'
                                                : 'noc-dashboard-body-map-body-container-map'
                                        }
                                    >
                                        <AcCustomNOCMap
                                            chargers={nocDashboardChargerList}
                                            center={{ mapCenter, setMapCenter }}
                                            zoom={{ mapZoom, setMapZoom }}
                                            enableUserInteraction={enableUserInteraction}
                                            handleSelectedChargerChange={handleSelectedChargerChange}
                                            selectedCharger={selectedCharger}
                                            darkModeEnable={false}
                                            prevCenter={{ prevMapCenter, setPrevMapCenter }}
                                        />

                                        <div className='noc-dashboard-watermark-text'>
                                            {watermarkText}
                                        </div>

                                        <div className='noc-dashboard-map-controls'>
                                            <CustomMapControl
                                                mapCenter={mapCenter}
                                                setMapCenter={setMapCenter}
                                                mapZoom={mapZoom}
                                                setMapZoom={setMapZoom}
                                                alertCount={Number(nocDashboardAlertsCount)}
                                                enableUserInteraction={enableUserInteraction}
                                                setEnableUserInteraction={setEnableUserInteraction}
                                                handleAlarmButtonClicked={() =>
                                                    handleAlertListToggle(false)
                                                }
                                            />
                                        </div>

                                        {/* Legends */}
                                        <div
                                            className={`noc-legends-wrapper ${
                                                showLegends ? 'show-legends' : ''
                                            }`}
                                        >
                                            <div className='noc-legends-panel'>
                                                <NocLegends showLegends={showLegends} />
                                            </div>

                                            <div
                                                className={
                                                    showLegends
                                                        ? 'noc-legends-toggle-btn-show'
                                                        : 'noc-legends-toggle-btn-hide'
                                                }
                                                onClick={() => setShowLegends((prev) => !prev)}
                                            >
                                                <Icon
                                                    iconClassName={
                                                        showLegends
                                                            ? 'noc-dashboard-legends-expand-collapse-icon'
                                                            : 'noc-dashboard-legends-expand-collapse-icon'
                                                    }
                                                />
                                                <div
                                                    className={
                                                        showLegends
                                                            ? 'noc-dashboard-show-legends-icon-container'
                                                            : 'noc-dashboard-hide-legends-icon-container'
                                                    }
                                                >
                                                    <IconWithTooltip
                                                        iconClassName={
                                                            showLegends
                                                                ? 'noc-dashboard-show-legends-icon'
                                                                : 'noc-dashboard-hide-legends-icon'
                                                        }
                                                        toolTipText={
                                                            showLegends ? 'Hide Legends' : 'Show Legends'
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Metric cards */}
                                        <div
                                            className={`noc-dashboard-noc-metric-cards-container ${
                                                showNocMetricCardBar ? 'expand' : 'collapse'
                                            }`}
                                        >
                                            <AcNocmetricCardOverlay
                                                chargerList={nocDashboardChargerList}
                                                alarmCounts={nocDashboardAlarmCounts}
                                            />
                                        </div>

                                        {/* Filters */}
                                        <div
                                            className={
                                                showSideBar
                                                    ? 'noc-dashboard-hide-sidebar-btn'
                                                    : 'noc-dashboard-show-sidebar-btn'
                                            }
                                            onClick={() => {
                                                setShowSideBar((prev) => !prev);
                                            }}
                                        >
                                            <div
                                                className={
                                                    showSideBar
                                                        ? 'noc-dashboard-expand-icon-container'
                                                        : 'noc-dashboard-collapse-icon-container'
                                                }
                                            >
                                                <div className='noc-dashboard-expand-collapse-icon'>
                                                    <IconWithTooltip
                                                        iconClassName={
                                                            showSideBar
                                                                ? 'noc-dashboard-hide-legends-icon'
                                                                : 'noc-dashboard-show-legends-icon'
                                                        }
                                                        toolTipText={
                                                            showSideBar
                                                                ? 'Hide Charger Detail Panel'
                                                                : 'Show Charger Detail Panel'
                                                        }
                                                    />
                                                </div>
                                                <Icon
                                                    iconClassName={
                                                        showSideBar
                                                            ? 'noc-dashboard-right-panel-toggle-charger-icon'
                                                            : 'noc-dashboard-right-panel-toggle-charger-icon'
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className={`noc-dashboard-toggle-metric-btn ${
                                                showNocMetricCardBar ? 'expanded' : 'collapsed'
                                            }`}
                                            onClick={() => setShowNocMetricCardBar((prev) => !prev)}
                                        >
                                            <div className='noc-dashboard-noc-metric-card-bar-expand-collapse-icon-container'>
                                                <IconWithTooltip
                                                    iconClassName={
                                                        showNocMetricCardBar
                                                            ? 'noc-dashboard-hide-metric-card-bar-icon'
                                                            : 'noc-dashboard-show-metric-card-bar-icon'
                                                    }
                                                    toolTipText={
                                                        showNocMetricCardBar
                                                            ? 'Hide Snapshot Tiles'
                                                            : 'Expand Snapshot Tiles'
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className='noc-dashboard-filter-box-container'>
                                            <CustomNocMapFilters
                                                filterHandler={handleFilterDataChange}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className={`noc-dashbaord-latest-charger-detail-record-container ${
                                            showSideBar ? 'open' : 'closed'
                                        }`}
                                    >
                                        <div className='content-wrapper'>
                                            <AcNocRightPanel
                                                latestChargerDetails={latestChargerDetails}
                                                latestChargerAlarmDetails={latestChargerAlarmDetails}
                                                latestChargerDetailsLoader={latestChargerDetailsLoader}
                                                sessionPlotData={nocDashboardChargingSessionsPlotData}
                                                energyPlotData={nocDashboardConsumedEnergyPlotData}
                                                uptimePlotData={nocDashboardChargerUptimePlotData}
                                                nocDashboardConnectorStatusData={
                                                    nocDashboardConnectorStatusData
                                                }
                                                alarmDurationRef={alarmDurationRef}
                                                selectedChargerRef={selectedChargerRef}
                                                searchTermRef={searchTermRef}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '8px',
                                            width: '68%',
                                            height: '100%',
                                        }}
                                    >
                                        <div
                                            style={{
                                                border: '1px solid rgba(226, 232, 240, 1)',
                                                borderRadius: '8px',
                                                height: '65%',
                                            }}
                                        >
                                            {
                                                (!nocDashbaordChargerSessionVolumeData || !nocDashboardChargerSessionPerfomanceData) ?
                                                    <div className="charger-version-trend-chart-loader" style={{ height: '400px' }}>
                                                        <CustomPulseLoader showLoader={true} size={20}/>
                                                    </div>
                                            :
                                            <>
                                            <ChargingSessionAreaChart
                                                
                                                title='Charging Session Performance'
                                                chargerPerformanceData={
                                                    nocDashboardChargerSessionPerfomanceData ?? []
                                                }
                                            />

                                            <StackedColumnChart
                                                
                                                chargerSessionVolumeData={
                                                    nocDashbaordChargerSessionVolumeData ?? []
                                                }
                                            />
                                            </>
                                            }
                                        </div>

                                        <div
                                            style={{
                                                border: '1px solid rgba(226, 232, 240, 1)',
                                                borderRadius: '8px',
                                                height: '35%',
                                                paddingTop:'5px',
                                                width: '100%',
                                            }}
                                        >
                                            {
                                            (!nocDashboardChargerAlarmData || !nocDashboardChargerUptimeData) ? <div className="charger-version-trend-chart-loader" style={{ height: '200px' }}>
                                                <CustomPulseLoader showLoader={true} size={20}/>
                                            </div>
                                            :
                                            <AlarmsUptimeTrendChart
                                                chargerAlarmData={nocDashboardChargerAlarmData ?? []}
                                                chargerUptimeData={nocDashboardChargerUptimeData ?? []}
                                            />
                                            }
                                        </div>
                                    </div>
                                    <div className='noc-dashbaord-charger-perfomance-container'>
                                        <div className='' style={{ height: '100%' }}>
                                            <AcNocChargerPerfomanceSidePanel
                                                handlePerformanceRankingNavChange={
                                                    handlePerformanceRankingNavChange
                                                }
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ThemeProvider>
    );
}

export default AcNocDashboard;
